const scalingPerImageId = {};

/* function add(imageId, scalingMetaData) {
  const imageURI = csUtils.imageIdToImageURI(imageId);
  scalingPerImageId[imageURI] = scalingMetaData;
}

function get(type, imageId) {
  if (type === 'scalingModule') {
    const imageURI = csUtils.imageIdToImageURI(imageId);
    return scalingPerImageId[imageURI];
  }
} */

function add(imageURI, scalingMetaData) {
  scalingPerImageId[imageURI] = scalingMetaData;
}

function get(type, imageURI) {
  if (type === 'scalingModule') {
    return scalingPerImageId[imageURI];
  }
}

export default { add, get };